import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
// The write-up is a full standalone HTML document (MathJax script,
// its own styles). Rendering it in an iframe keeps its markup and
// scripts isolated from the rest of the app.
import skeletonHtmlUrl from "./skeleton.html?url";

function MiterSkeletonWriteup(): JSX.Element {
  return (
    <iframe
      src={skeletonHtmlUrl}
      title="Miter-skeleton algorithm write-up"
      style={{ display: "block", width: "100vw", height: "100vh", border: "none" }}
    />
  );
}

export const Route = createFileRoute("/debug/geom/miter-skeleton/skeleton")({
  component: MiterSkeletonWriteup,
});
